import { useSearchParams } from 'react-router';
import AddImagesToHCPanel from '../utils/panels/AddImagesToHCPanel';

function AddImagesToHC() {

  const [searchParams] = useSearchParams();
  const patient: string =searchParams.get('patientID');
  const professional: string = searchParams.get('professionalID');

  return (<AddImagesToHCPanel patient={patient} professional={professional}  />);
}

export default AddImagesToHC;
